import { render } from "./investigation-details-modal.html?vue&type=template&id=2f4d8d94&scoped=true&ts=true&external"
import script from "./investigation-details-modal.ts?vue&type=script&lang=ts&external"
export * from "./investigation-details-modal.ts?vue&type=script&lang=ts&external"

import "./investigation-details-modal.scss?vue&type=style&index=0&id=2f4d8d94&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4d8d94"]])

export default __exports__